import { styled } from '@mui/material';

export const Styles = {
  HighlightedAd: styled('div')({
    background: '#FFFF',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '10px',
    width: '350px',
    padding: '15px',
    cursor: 'pointer',
    marginTop: '25px'
  }),
  AdImage: styled('img')({
    width: '320px',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '5px',
    marginTop: '15px'
  }),
  AdTitle: styled('h1')({
    fontSize: '18px',
    fontWeight: '600',
    color: '#04682e',
    margin: '0 auto'
  }),
  HighlightText: styled('p')({
    fontSize: '18px',
    color: '#382414',
    fontWeight: 'bold',
    margin: '0 auto'
  })
};
